import { useEffect, useState } from "react";
import { AdminUser } from "./Admin";
import axios from "axios";
import LoadSpinner from "../Utilities/LoadSpinner";

const AdminManager = () => {
  const [admins, setAdmins] = useState<AdminUser[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [role, setRole] = useState<string>(""); // Set initial value to empty string

  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchAdmins = async () => {
    // Fetch all admins
    setLoading(true);
    const response = await axios.get(`${apiUrl}/Admin/listAdmins`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    // Set admins
    setAdmins(response.data as AdminUser[]);
    // Set loading to false
    setLoading(false);
  };

  useEffect(() => {
    fetchAdmins();
  }, []); // Empty dependency array to run only once

  const createAdmin = async () => {
    try {
      await axios.post(
        `${apiUrl}/Admin/createAdmin`,
        {
          email,
          userName: name,
          role,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      setEmail("");
      setName("");
      setRole(""); // Reset role to empty string
      // Refresh the list of admins
      fetchAdmins();
    } catch (error) {
      console.error("Failed to create admin:", error);
      alert("Failed to create admin. Please try again.");
    }
  };

  const deleteAdmin = async (id: string) => {
    await axios.delete(`${apiUrl}/Admin/deleteAdmin/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    // Refresh the list of admins
    fetchAdmins();
  };

  if (loading) {
    return (
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <LoadSpinner />
      </div>
    );
  }

  return (
    <>
      <section className="container admin-management-section">
        <h2>Create Admin</h2>
        <div className="create-admins__crud">
          <div className="form-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="form-control"
            >
              <option disabled value="">
                Select Role
              </option>
              <option value="Admin">Admin</option>
              <option value="SuperAdmin">SuperAdmin</option>
            </select>
          </div>
          <button className="btn btn-primary" onClick={createAdmin}>
            Create Admin
          </button>
        </div>
        <div className="mt-4">
          <h2>Admins List</h2>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="admin-list">
              <div className="admin-list__header">
                <div>Email</div>
                <div>Role</div>
                <div>Actions</div>
              </div>
              {admins.map((admin) => (
                <div className="admin-list__item" key={admin.id}>
                  <div>{admin.email}</div>
                  <div>{admin.role}</div>
                  <div>
                    <button
                      className="btn btn-danger"
                      onClick={() => deleteAdmin(admin.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default AdminManager;
